'use strict';

/**
 *
 * Dependecies
 *
 */

 // Polyfills
import intersectionObserver from 'expose?$!expose?intersectionObserver!intersection-observer'
import '@babel/polyfill';
import 'svgxuse';

/*jshint unused:false*/

import jQuery from 'expose?$!expose?jQuery!jquery';
import angular from '!imports?this=>window!exports?angular!angular';
import angularResource from 'angular-resource';
import ngCookies from 'angular-cookies';
import angularSanitize from 'angular-sanitize';
import uiRouter from 'angular-ui-router';
import angularTranslate from 'angular-translate';
import moment from 'expose?moment!moment';
import angularAnimate from 'angular-animate';
import angularTouch from 'angular-touch';
import ngStorage from 'ngstorage';
import angularCookie from 'angular-cookie';
import ngInfiniteScroll from 'ng-infinite-scroll/build/ng-infinite-scroll';
import jqueryWaypoints from 'jquery-waypoints/waypoints';
import sha1 from 'expose?sha1!sha-1';
import angulartics from 'angulartics/dist/angulartics.min';
import string from 'string';
import jqueryIframetracker from 'jquery.iframetracker';
import jqueryUi from 'imports?define=>false,this=>window!jquery-ui';
import jqueryUiMouse from 'imports?define=>false,this=>window!jquery-ui/ui/widgets/mouse';
import echojs from 'expose?echo!imports?this=>window!echo-js/dist/echo';
import oclazyLoad from 'oclazyload';
import Raven from 'expose?Raven!raven-js/dist/raven.js';
import RavenPluginAngular from 'imports?define=>false,this=>window,exports=>false!raven-js/dist/plugins/angular.js';
import slickCarousel from 'slick-carousel';
import angularSlickCarousel from 'angular-slick-carousel';
import slickCarouselCss from 'slick-carousel/slick/slick.css';
import slickCarouselCssTheme from 'slick-carousel/slick/slick-theme.css';
import Modernizr from '!imports?this=>window!exports?Modernizr!modernizr';
import whatsappSharing from '!imports?this=>window!whatsapp-sharing/dist/whatsapp-button';

import externalPagesTracker from './assets/vendor/js/external_pages_tracker.js';
import Filepicker from './assets/vendor/js/filepicker.js';
import froogaloop2 from './assets/vendor/js/froogaloop2.min.js';
import mikesCode from './assets/vendor/js/mikesCode.js';
import platform from './assets/vendor/js/platform.js';
// import playerApi from 'expose?YT!expose?YTConfig!./assets/vendor/js/player_api.js';
import touchPunch from './assets/vendor/js/touch-punch.js';
import wx from '!imports?define=>false,this=>window!./assets/vendor/js/jweixin-1.0.0.js';

/**
 *
 * Styles
 *
 */

import lessStyles from './assets/styles/_main-prod.less'
import scssStyles from './assets/styles/_main-prod.scss'

/**
 *
 * App
 *
 */

import nownessApp from './app/app.module';



// WEBPACK FOOTER //
// ./index.js